// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__2-IMT","clickedWithMouse":"MenuLabel_clickedWithMouse__3mNSR","isOpen":"MenuLabel_isOpen__1kyqQ"};